/**
 * Created by face on 2017/11/4 17:13.
 */
import * as React from 'react';
import { renderRoutes } from 'react-router-config';
import { Switch } from 'react-router-dom';
import BrowserRouter from '../components/BrowserRouter/BrowserRouter';
import routes from './router';
import './index.scss';
import { observer } from 'mobx-react';
import createStore from '../redux/store';
import { Provider } from 'react-redux';
import Authentication from './Authentication';

export const reduxStore = createStore();

@observer
export class Main extends React.Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
    }

    public componentDidMount() {
        this.init();
    }

    public init() {}

    public render() {
        return (
            <Provider store={reduxStore}>
                <Authentication>
                    <BrowserRouter>
                        <Switch>
                            {renderRoutes(routes)}
                        </Switch>
                </BrowserRouter>
                </Authentication>
                
            </Provider>
        );
    }
}
